// extracted by mini-css-extract-plugin
export var addToCartButton = "_sr-b";
export var arrowButtonContainer = "_sr-9";
export var arrowButtonIcon = "_sr-a";
export var carouselArrowButton = "_sr-6";
export var carouselElementContainer = "_sr-1";
export var galleryThumbnail = "_sr-d";
export var galleryThumbnailImage = "_sr-e";
export var left = "_sr-7";
export var productDisplayCarouselContainer = "_sr-0";
export var productTileContainer = "_sr-2";
export var productTileImage = "_sr-4";
export var productTileImageContainer = "_sr-3";
export var productTileTitle = "_sr-5";
export var right = "_sr-8";
export var sliderOverflow = "_sr-c";